import styled from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";

export const List = styled.div`
  position: absolute;
  top: 150vh;
  left: ${calculateResponsiveSize(60)};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  z-index: 1;
  ${mediaMax("tabletLandscape")} {
    display: none;
  }
`;

export const Item = styled.span`
  display: inline-block;
  margin-bottom: ${calculateResponsiveSize(24)};
  color: ${({ $color }) => ($color === "dark" ? `#1E1E1E;` : "#fff;")};
  font-size: ${calculateResponsiveSize(14)};
  font-family: "proxima_nova_semibold", san-serif;
  font-style: normal;
  /* font-weight: 600; */
  line-height: 1;
  letter-spacing: ${calculateResponsiveSize(1.4)};
  text-transform: uppercase;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  text-align: left;
  border-bottom: ${calculateResponsiveSize(2)} solid transparent;
  &::after {
    content: "";
    display: block;
    margin-top: ${calculateResponsiveSize(2)};
    height: ${calculateResponsiveSize(2)};
    background: ${({ $color }) => ($color === "dark" ? `#1E1E1E;` : "#fff;")};
    width: 0;
    transition: width 0.5s;
  }
  ${({ $active }) =>
    $active &&
    `&::after {
      width: 100%;
    };`};
  &:hover {
    &::after {
      width: 100%;
    }
  }
`;
